import BackgroundStyle from 'data/BackgroundStyle';
import { FrameData } from 'data/FlyerData';
import { FrameType } from 'data/FrameType';
import { createFrameFromData } from 'data/FrameUtils';
import { PictureFrame } from 'data/PictureFrame';
import { REPLACE_FRAME, selectFrame } from 'state/actions';
import { getFrameById, getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { getBackgroundStyleFromImageFile, isUUID, newUUID, pause } from 'utils';
import { Command, CommandFunction } from './Command';

export class ReplacePictureFrameCommand extends Command {
  layerId: string;
  frameId: string;
  newFrameId: string;
  frameData: FrameData;
  file: File;
  constructor(layerId: string, frameId: string, file: File) {
    super();
    this.layerId = layerId;
    this.frameId = frameId;
    this.file = file;
    this.newFrameId = isUUID(frameId) ? newUUID() : frameId;
  }
  execute(firstTime?: boolean | undefined): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = getFrameById(flyer, this.frameId);
      if (layer && frame) {
        if (firstTime) {
          this.frameData = frame.asData(false);
          this.frameData.id = frame.id;
          dispatch(selectFrame(null));
        }
        const { resolution } = flyer;
        // const url = URL.createObjectURL(file);
        const newFrame = new PictureFrame(resolution.width, resolution.height);
        newFrame.id = this.newFrameId;
        newFrame.file = this.file;
        newFrame.filename = this.file.name;
        const fileType = this.file.type.split('/')[0];
        newFrame.type =
          fileType === 'video' ? FrameType.Video : FrameType.Image;
        newFrame.backgroundStyle =
          newFrame.type === FrameType.Video
            ? BackgroundStyle.Opaque
            : await getBackgroundStyleFromImageFile(this.file);
        await newFrame.load();
        const oldAspectRatio =
          frame.boundingBox.width / frame.boundingBox.height;
        const newAspectRatio =
          newFrame.boundingBox.width / newFrame.boundingBox.height;
        if (oldAspectRatio === newAspectRatio) {
          newFrame.boundingBox = frame.boundingBox;
        } else {
          // share center
          const box = frame.boundingBox;
          const cx = box.x + box.width * 0.5;
          const cy = box.y + box.height * 0.5;
          const hw = newFrame.boundingBox.width * 0.5;
          const hh = newFrame.boundingBox.height * 0.5;
          newFrame.boundingBox = new PIXI.Rectangle(
            cx - hw,
            cy - hh,
            hw * 2,
            hh * 2
          );
        }
        dispatch({
          type: REPLACE_FRAME,
          layer,
          oldFrame: frame,
          newFrame
        });
        if (firstTime) {
          await pause(1);
          dispatch(selectFrame(newFrame));
        }
      }
    };
  }
  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      const frame = getFrameById(flyer, this.newFrameId);
      if (layer && frame) {
        const newFrame = createFrameFromData(
          this.frameData,
          layer.stageWidth,
          layer.stageHeight
        );
        await newFrame.load();
        dispatch({
          type: REPLACE_FRAME,
          layer,
          oldFrame: frame,
          newFrame
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/ReplacePictureFrameCommand.ts